import { render, staticRenderFns } from "./form-checkbox-text.vue?vue&type=template&id=6c515058&scoped=true&"
import script from "./form-checkbox-text.vue?vue&type=script&lang=js&"
export * from "./form-checkbox-text.vue?vue&type=script&lang=js&"
import style0 from "./form-checkbox-text.vue?vue&type=style&index=0&id=6c515058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c515058",
  null
  
)

export default component.exports